import { Middleware } from "../Middleware";
import { MiddlewareInterface } from "../MiddlewareInterface";
import Constants from "../../Action/Constants";
import { ChargeInterface } from "../../Entity/Entities/Charge/ChargeInterface";
import { EventInterface } from "../../Entity/Entities/Event/EventInterface";
import { PaymentInterface } from "../../Entity/Entities/Payment/PaymentInterface";

class EmailSendWillMount extends Middleware implements MiddlewareInterface {
	public component: any;

	constructor() {
		super();
	}

	public process(): void {
		const id: number = parseInt(this.component.props.params?.id, 10);
		const entityName: string = this.component.props.params?.entity;

		switch (entityName) {
			case "charge":
				{
					this.component.props.dispatch({
						type: Constants.GLOBAL_CHARGE_FOR_CHARGE_DETAILS_PAGE,
						payload: {
							chargeId: id
						},
						onSuccess: (charge: ChargeInterface) => {
							if (!charge) {
								return this.component.redirectBack();
							}
							this.component.setState({
								entityName: entityName
							}, () => this.component.initializePage(charge));
						},
						onError: this.component.redirectBack
					});
				}
				break;
			case "payment":
				{
					this.component.props.dispatch({
						type: Constants.GLOBAL_PAYMENT_FOR_PAYMENT_DETAILS_PAGE,
						payload: {
							paymentId: id
						},
						onSuccess: (payment: PaymentInterface) => {
							if (!payment) {
								return this.component.redirectBack();
							}
							this.component.setState({
								entityName: entityName
							}, () => this.component.initializePage(payment));
						},
						onError: this.component.redirectBack
					});
				}
				break;
			case "task":
				{
					this.component.props.dispatch({
						type: Constants.GLOBAL_EVENT_UPDATE_CLEAR
					});

					this.component.props.dispatch({
						type: Constants.GLOBAL_EVENT_FOR_EVENT_DETAILS_PAGE,
						payload: {
							eventId: id
						},
						onSuccess: (task: EventInterface) => {
							if (!task) {
								return this.component.redirectBack();
							}

							this.component.setState({
								entityName: entityName
							}, () => this.component.initializePage(task));
						},
						onError: this.component.redirectBack
					})
				}
				break;
			case "statement":
				{
					const statementData = this.component.props.app?.fetchedStatementDatas?.find(statementData => statementData?.id === id);

					if (!!statementData) {
						this.component.setState({
							entityName: entityName
						}, () => {
							this.component.initializePage(statementData);
						});
					} else {
						this.component.props.dispatch({
							type: Constants.GLOBAL_FINANCIAL_STATEMENT_DATA_START,
							payload: {
								id: id
							},
							onSuccess: statementDatas => {
								if (!statementDatas.length) {
									return this.component.redirectBack();
								}

								this.component.setState({
									entityName: entityName
								}, () => {
									const statement = statementDatas?.find(data => data?.id === id);
									this.component.initializePage(statement);
								})
							},
							onError: this.component.redirectBack
						})
					}
				}
				break;
			case "contract":
				{
					const contract = this.component.props.app?.contracts
						.find(contract => contract?.id === id);

					if (!contract) {
						return this.component.redirectBack();
					}

					this.component.setState({
						entityName: entityName
					}, () => {
						this.component.initializePage(contract);
					});
				}
				break;
			case "statements-request-review":
				{
					this.component.setState({
						entityName: entityName
					}, () => {
						this.component.initializePage();
					});
				}
				break;
			case "tenant-login-portal-link":
				{
					const tenant = this.component.props.app?.persons
						.find(person => person?.id === id);

					if (!tenant) {
						return this.component.redirectBack();
					}

					this.component.setState({
						entityName: entityName
					}, () => {
						this.component.initializePage(tenant);
					});
				}
				break;
			case "new-contract":
				{
					const contract = this.component.props.app?.contracts
						.find(contract => contract?.id === id);

					if (!contract) {
						return this.component.redirectBack();
					}

					this.component.setState({
						entityName: entityName
					}, () => {
						this.component.initializePage(contract);
					});
				}
				break;

			case "renewed-contract":
				{
					const contract = this.component.props.app?.contracts
						.find(contract => contract?.id === id);
					if (!contract) {
						return this.component.redirectBack();
					}
					this.component.setState({
						entityName: entityName
					}, () => {
						this.component.initializePage(contract);
					});
				}
				break;
			default:
				this.component.redirectBack();
				break;
		}
	}
}

export default new EmailSendWillMount();
